import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {testingOptions as testingOptionsState} from './root.selector';

export const testingDate = createSelector(testingOptionsState, get('date'));

export const lastPeriodId = createSelector(
  testingOptionsState,
  get('lastPeriodId'),
);

export const latestAcceptedPeriodId = createSelector(
  testingOptionsState,
  get('latestAcceptedPeriodId'),
);

export const openPeriodId = createSelector(
  testingOptionsState,
  get('openPeriodId'),
);

export const currentPeriodId = createSelector(
  testingOptionsState,
  get('currentPeriodId'),
);
